/**
 * Faixa do banner (PartnerSlot `bar`, §12.5; D2 do responsável, ORD-F-133/134; docs/DECISOES.md §77). Só com
 * `features.partner_slots` (desligada por padrão; no dia 25 também é a chave que decide, ORD-F-134) e nunca na TV.
 *
 * Com a chave ligada, a caixa da faixa (`.partner-bar-box`, 32 px; 44 px com `pointer: coarse`) existe desde a 1ª
 * montagem, dentro de `.top-bars`, e o boot já a desconta da viewport (main.tsx → bootLayout, AC-4.1-05): a peça chega
 * depois sem deslocar nada (sem CLS). Se não houver peça válida (arquivo ausente ou inválido, `enabled = false`, fora
 * da validade), a caixa recolhe (`data-state="off"`), e volta se a releitura de 30 min trouxer a peça.
 *
 * Sem pedaço próprio (DECISOES §77; ORD-F-087): com um `import()` novo o Rolldown repartia o JS crítico, e a medida de 9
 * cargas alternadas deu +204 ms de LCP na apuração do celular com a chave DESLIGADA (+100 ms na página inicial). A
 * leitura, a validação e o componente (app/partnerLive.tsx) ficam no `index`; com a chave desligada nada monta e nada é
 * buscado (AC-12.5-02).
 */
import './partnerSlot.css';
import { ErrorBoundary } from '../features/errors/ErrorBoundary';
import { useConfig, useLayout, useUi } from '../state/hooks';
import { LivePartnerBar } from './partnerLive';
import { partnerBarState } from './partnerState';

/** Pura. A caixa da faixa monta (a mesma regra do boot, main.tsx): chave ligada e fora da TV. */
export function partnerBarWanted(partnerSlots: boolean, tv: boolean): boolean {
  return partnerSlots && !tv;
}

/**
 * `waitForData`: a faixa só busca a peça depois do 1º dado da apuração (não disputa o LCP do 1º número); a casca da
 * apuração (App → AppShell) liga, as telas das fases não esperam (sem a apuração na tela, o dado nunca chega).
 */
export function PartnerBarSlot({ waitForData = false }: { waitForData?: boolean }) {
  const cfg = useConfig();
  const ui = useUi();
  const { mode } = useLayout();
  if (!partnerBarWanted(cfg.features.partner_slots, ui.tv.on || mode === 'tv')) return null;
  return (
    <div class="partner-bar-box" data-testid="partner-bar-box" data-state={partnerBarState.value}>
      <ErrorBoundary name="partner-bar" quiet>
        <LivePartnerBar waitForData={waitForData} />
      </ErrorBoundary>
    </div>
  );
}
